import * as React from "react"
import { Button, Spinner, ButtonProps } from "react-bootstrap"

interface CountdownButtonProps extends ButtonProps {
  children?: React.ReactNode  
  waitSeconds: number
  interval:number

}
interface CountdownButtonState  {
  //interval:number
  remaining:number
  timeRemainingString:string

}


export default class CountdownButton extends React.PureComponent<CountdownButtonProps, CountdownButtonState> {
 countdownTimer:number = 0
 state: CountdownButtonState = {remaining: this.props.waitSeconds, timeRemainingString: ""}
 componentDidMount() {
    this.startCounter();
  }
  componentWillUnmount() {
    this.stopCounter()
  };   

  startCounter(){
    this.stopCounter()
    if(this.props.waitSeconds <= 0){
        return
    }
    let interval = 1000
    if(this.props.interval > 0){
        interval = this.props.interval * 1000
    }
    this.countdownTimer = window.setInterval(this.onInterval, interval, this)
  }

  stopCounter(){
    if(this.countdownTimer > 0){
        window.clearInterval(this.countdownTimer)
        this.countdownTimer = 0
    }
  }

  onInterval(src:CountdownButton) {
    let remaining: number = src.state.remaining
    if(remaining > 0){
        remaining--
    }
    const timeRemainingString = src.getTimeRemainingString() 
    src.setState({remaining:remaining, timeRemainingString:timeRemainingString})
    if(remaining <= 0){
       src.stopCounter()
       return
    }
  }

  getTimeRemainingString(){
    const text = this.props.children ? this.props.children.toString() : ""
    if(this.state.remaining > 0){
        return text + " (" + this.state.remaining + ")"
    }
    return text
  }
  render() {
    const { disabled, className, children, ...buttonProps } = this.props
    const actualDisabled = disabled || this.state.remaining > 0
    const actualClassName = `${className || ""} btn-icon`
    const text =  this.getTimeRemainingString()
    return (
      <Button {...buttonProps} className={actualClassName} disabled={actualDisabled}>
        {text}
      </Button>)
  }
}
